export default {
  // 備忘錄
  utils: {
    plus: '加',
    reduce: '減',
    ride: '乘',
    except: '除',
    Involution: '乘方',
    leftBrackets: '左括號',
    lrightBrackets: '右括號',
    chuanLian: '串聯',
    dengyu: '等於',
    budengyu: '不等於',
    dayu: '大於',
    xiaoyu: '小於',
    dayudengyu: '大於或等於',
    xiaoyugengyu: '小於或等於',
    dataAndTime: '日期和時間',
    example: '示例',
    formulaInfo1: '返回指定日期字段中年份的正數',
    formulaInfo2: '返回指定日期字段中月份的正數',
    formulaInfo24: '返回指定日期字段中某月的天數',
    formulaInfo3: '返回表示當前時刻的日期時間',
    formulaInfo4: '返回表示當前時刻的日期',
    formulaInfo5: '返回兩個日期之間的天數。 Y:年、M:月、D:日、H:時、N:分、S:秒',
    formulaInfo6:
      '在向指定日期加上壹段時間的基礎上, 返回新的 datetime 值; Y:年、M:月、D:日、H:時、N:分、S:秒',
    formulaInfo7: '返回兩個日期之間的時間, Y:年、M:月、D:日',
    formulaInfo42: "未聯系天數=EXTRACT('D','current_date',2017-12-25), 實時計算結果值",
    formulaInfo44: '返回兩個日期之間的時間 Y:年、M:月、D:日、H:時、N:分、S:秒',
    formulaInfo45: "時長=EXTRACT('H','current_timestamp',2017-12-25 20:15:00)，實時計算結果值",
    formulaInfo8: '通過年、月、日創建日期',
    number: '數字',
    formulaInfo9: '返回數值的絕對值(不含正負號的數字)',
    formulaInfo46: '將小寫數字轉換成中文大寫',
    logic: '邏輯',
    formulaInfo10:
      '如果條件滿足(布爾表達式返回 TRUE 時), 則在 IF 關鍵字及其條件之後執行 語句; 可選的 ELSE 關鍵字引入備用的 語句，當不滿足 IF 條件時，就執行這個(ELSE)語句',
    formulaInfo11:
      "IF 分數==100 THEN 'AA' ELSE IF 分數>=90 THEN 'A' ELSE IF 分數>=80 THEN 'B' ELSE IF 分數>=70 THEN 'C' ELSE IF 分數>=60 THEN 'D' ELSE 'F' END",
    formulaInfo12:
      '確定表達式是否為空(空白), 如果是則返回 TRUE(真); 如果它包含壹個值，則該函數返回 FALSE(假)',
    formulaInfo13:
      'ISNULL(訂單.總金額,0)若訂單.總金額不為NULL則顯示訂單.總金額，若為NULL則顯示逗號後面的0',
    formulaInfo14: '檢查是否所有參數均為真, 如果所有參數均為真則返回TRUE',
    formulaInfo15: '檢查表達式是否具有值,如果沒有值則發返回TRUE',
    formulaInfo16: '反函數, 用戶來確保壹個值不等於某壹個特定的值',
    formulaInfo17: "IF NOT(年齡>=18) THEN '未成年，不能進入遊戲' END",
    formulaInfo18: '文本值為數字時，返回TRUE，反之FALSE',
    formulaInfo19: '檢查任壹參數是否為真, 如果有壹個參數為真則返回TRUE',
    formulaInfo20: '檢查text是否包含compare_text，如果是則返回TRUE',
    formulaInfo21: "CONTAINS(客戶地址,'深圳市')=TRUE",
    formulaInfo22: '如果文本與正則表達式regex_text相匹配，則返回TRUE',
    formulaInfo23: "REGEX(手機,'^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$)')",
    text: '文本',
    formulaInfo25: '返回從文本字符串開頭算起的指定數量的字符',
    formulaInfo26: '返回指定的文本字符串中所含的字符數',
    formulaInfo27: '返回從文本字符串右邊算起的指定數量的字符',
    formulaInfo28: '將壹個值轉換為使用標準顯示格式的文本',
    formulaInfo29: '將文本字符串轉換為數字類型',
    formulaInfo30: '給定字符串的起始位置和長度, 返回字符串中間的字符',
    formulaInfo31: '檢查文本是否以特定字符開頭, 如果是則返回TRUE，否則返回FALSE',
    formulaInfo43: "BEGINS(會員卡號,'801')",
    summary: '匯總',
    formulaInfo32: '返回組中的各項項數',
    formulaInfo33: 'COUNT(產品.產品編號) 返回組中的項數',
    formulaInfo34: '返回組中各項的和。',
    formulaInfo35: '客戶成交總金額=SUM(合同.總金額)',
    formulaInfo36: '返回壹系列數字中的最小數字',
    formulaInfo37: '學員最低成績=MIN(成績.分數)',
    formulaInfo38: '返回壹系列數字中的最大數字',
    formulaInfo39: '學員最低成績=MAN(成績.分數)',
    formulaInfo40: '返回組中的平均值',
    formulaInfo41: '會員平均消費=AVG(銷售訂單.金額)',
    noPicture: '無圖',
    xiuxian: '休閑',
    relax: '輕松',
    business: '商務',
    hezuo: '合作',
    meeting: '會議',
    up: '向上',
    administration: '行政',
    quwei: '趣味',
    silent: '寂靜',
    dushi: '都市',
    qinliang: '清涼',
    menghuan: '夢幻',
    richu: '日出',
    chuxia: '初夏',
    reqing: '熱情',
    yaoyuan: '遙遠',
    shenye: '夜深',
    work: '工作',
    B2cPlatform: '電商平臺',
    ITInternet: 'IT互聯網',
    teachTrain: '教育培訓',
    houseCenter: '房產中介',
    jinrongBaoxian: '金融保險',
    wuliuYunshu: '物流運輸',
    jiazhengFuwu: '家政服務',
    qicheFuwu: '汽車服務',
    yiliaoZhiyao: '醫療制藥',
    lvshiAnjian: '律師案件',
    nonglinye: '農林牧漁業',
    guangaoMeiti: '廣告媒體',
    other: '其他',
    xingzhengBangong: '行政辦公',
    renliZiyuan: '人力資源',
    kehuGuanli: '客戶管理',
    huiyuanGuanli: '會員管理',
    shouhouGuanli: '售後管理',
    jinxiaocun: '進銷存',
    cangkuGuanli: '倉儲管理',
    subMenu: '子菜單',
    view: '視圖',
    chart: '圖表',
    taskYongdaotu: '任務泳道圖',
    logOutOfDate: '登錄過期',
    networkExceptionTryAgain: '網絡異常, 請稍候重試',
    browserDontSupportCanvas: '您的瀏覽器版本不支持canvas',
    pwdRuleInfo1: '不符合密碼最小長度',
    pwdRuleInfo2: '需包含字母和數字字符',
    pwdRuleInfo3: '需包含字母、數字和特殊字符',
    pwdRuleInfo4: '需包含數字和大小寫字母',
    pwdRuleInfo5: '需包含數字、大小寫字母和特殊字符',
    listChart: '列表式',
    summaryChart: '匯總式',
    matrixChart: '矩陣式',
    barChart: '柱狀圖',
    stackChart: '堆疊柱狀圖',
    stripChart: '條形圖',
    stackStripChart: '堆疊條形圖',
    areachart: '面積圖',
    scatterChart: '散點圖',
    linechart: '折線圖',
    pie1Chart: '餅圖1',
    pie2Chart: '餅圖2',
    ringChart: '環形圖',
    funnelChart: '漏鬥圖',
    mapChart: '地圖',
    gaugeChart: '儀表圖',
    valueNum: '數值1',
    valueSvg: '數值2',
    radarChart1: '雷達圖1',
    radarChart2: '雷達圖2',
    ganttChart: '甘特圖',
    dimensionValue1: '1個或多個維度，1個或多個數值',
    dimensionValue2: '1個或2個維度，1-3個數值',
    dimensionValue3: '1個維度，1個數值',
    dimensionValue4: '1個數值',
    dimensionValue5: '1個維度(省市區組件)，1個數值',
    dimensionValue6: '1個維度，1個或多個數值',
    dimensionValue7: '1-3個維度，1個或多個數值',
    selectEmoji: '選擇表情',
    emoji1: '[呲牙]',
    emoji2: '[调皮]',
    emoji3: '[汗]',
    emoji4: '[偷笑]',
    emoji5: '[拜拜]',
    emoji6: '[打你]',
    emoji7: '[擦汗]',
    emoji8: '[猪头]',
    emoji9: '[玫瑰]',
    emoji10: '[流泪]',
    emoji11: '[快哭了]',
    emoji12: '[嘘]',
    emoji13: '[酷]',
    emoji14: '[抓狂]',
    emoji15: '[委屈]',
    emoji16: '[屎]',
    emoji17: '[炸弹]',
    emoji18: '[菜刀]',
    emoji19: '[可爱]',
    emoji20: '[色]',
    emoji21: '[害羞]',
    emoji22: '[得意]',
    emoji23: '[吐]',
    emoji24: '[微笑]',
    emoji25: '[发火]',
    emoji26: '[尴尬]',
    emoji27: '[惊恐]',
    emoji28: '[冷汗]',
    emoji29: '[心]',
    emoji30: '[嘴唇]',
    emoji31: '[白眼]',
    emoji32: '[傲慢]',
    emoji33: '[难过]',
    emoji34: '[惊讶]',
    emoji35: '[疑问]',
    emoji36: '[睡]',
    emoji37: '[亲亲]',
    emoji38: '[憨笑]',
    emoji39: '[爱情]',
    emoji40: '[衰]',
    emoji41: '[撇嘴]',
    emoji42: '[奸笑]',
    emoji43: '[奋斗]',
    emoji44: '[发呆]',
    emoji45: '[右哼哼]',
    emoji46: '[抱抱]',
    emoji47: '[坏笑]',
    emoji48: '[企鹅亲]',
    emoji49: '[鄙视]',
    emoji50: '[晕]',
    emoji51: '[大兵]',
    emoji52: '[拜托]',
    emoji53: '[强]',
    emoji54: '[垃圾]',
    emoji55: '[握手]',
    emoji56: '[胜利]',
    emoji57: '[抱拳]',
    emoji58: '[枯萎]',
    emoji59: '[米饭]',
    emoji60: '[蛋糕]',
    emoji61: '[西瓜]',
    emoji62: '[啤酒]',
    emoji63: '[瓢虫]',
    emoji64: '[勾引]',
    emoji65: '[哦了]',
    emoji66: '[手势]',
    emoji67: '[咖啡]',
    emoji68: '[月亮]',
    emoji69: '[匕首]',
    emoji70: '[发抖]',
    emoji71: '[菜]',
    emoji72: '[拳头]',

    // 2021-03-31
    formulaInfo47: '在日期時間字段中返回小時數',
    formulaInfo48: '在日期時間字段中返回分鐘數',
    formulaInfo49: '檢查2個定位組件的定位範圍是否在300米內，如果不在範圍則返回失敗消息提示',
    formulaInfo50:
      '銷售員打卡=NOT( LOCATION ( 客戶地址，銷售員打卡地址，300) )，表示銷售員打卡地址必須在客戶的300米內才允許',
    formulaInfo51:
      "水果分類銷售次數=COUNT(CASE WHEN {產品類型}=='水果' THEN {產品編號} ELSE null END)，代表求水果分類的銷售次數，不是蔬果分類的返回為0",
    formulaInfo52:
      "客戶成交總金額=SUM(CASE WHEN {合同狀態}=='已簽約' THEN {合同.總金額} ELSE 0 END)",
    formulaInfo53:
      "會員平均消費=AVG（CASE WHEN {會員狀態}=='會員' THEN {銷售訂單.金額} ELSE 0 END）",
    stopMember: '停用人員'
  }
}
